import { Button, Form } from "react-bootstrap";
import { FilterArea } from "./FilterArea";
import CachedIcon from "mdi-react/CachedIcon";
import Select from "react-select";

export function HeaderArea({
  filterParams,
  setFilterParams,
  refetch,
  data,
  VendorPayment,
  sortOptions,
}) {
  return (
    <>
      <div className="d-flex justify-content-start m-4 pt-3">
        <Form.Group>
          <Form.Check
            inline
            id="onlyItems"
            label="Filter By Item"
            name="onlyItems"
            type="checkbox"
            checked={filterParams?.onlyItems === true}
            onChange={(e) => {
              setFilterParams((prev) => ({
                ...prev,
                page: 1,
                onlyItems: e.target.checked,
              }));
            }}
          />
        </Form.Group>
      </div>

      <div className="d-flex align-items-baseline">
        <div className="d-flex align-items-baseline mx-4">
          <Button
            onClick={() => refetch()}
            variant=""
            className="bg-light-blue border-0 text-primary"
          >
            <CachedIcon />
          </Button>
          <div className="d-flex align-items-baseline mx-4">
            <div className="mx-3" style={{ zIndex: 999 }}>
              <Select
                styles={{
                  control: (base) => ({ ...base, width: "12rem" }),
                }}
                classNamePrefix="form-select-store"
                menuPosition="fixed"
                isSearchable={false}
                placeholder="Sort By Price"
                options={sortOptions.filter(
                  (item) =>
                    item.value === "highest-price" ||
                    item.value === "lowest-price",
                )}
                value={sortOptions.find(
                  (item) => item.value === filterParams.sort,
                )}
                onChange={({ value }) =>
                  setFilterParams((prev) => ({
                    ...prev,
                    page: 1,
                    sort: value,
                  }))
                }
              />
            </div>
            <FilterArea
              filterParams={filterParams}
              setFilterParams={setFilterParams}
            />
          </div>
        </div>

        <div className="d-flex align-items-baseline mb-4 mx-4">
          <div className="mx-4" />
          <div className="mx-3" style={{ zIndex: 999 }}>
            <Select
              styles={{
                control: (base) => ({ ...base, width: "12rem" }),
              }}
              classNamePrefix="form-select-store"
              menuPosition="fixed"
              isSearchable={false}
              placeholder="All Item"
              options={data?.itemsData}
              value={data?.itemsData?.find(
                (item) => item.value === filterParams.item,
              )}
              onChange={({ value }) =>
                setFilterParams((prev) => ({
                  ...prev,
                  page: 1,
                  item: value,
                }))
              }
            />
          </div>

          <div className="mx-3" style={{ zIndex: 999 }}>
            <Select
              styles={{
                control: (base) => ({ ...base, width: "12rem" }),
              }}
              classNamePrefix="form-select-store"
              menuPosition="fixed"
              isSearchable={false}
              placeholder="Payment Search"
              options={VendorPayment}
              value={VendorPayment?.find(
                (item) => item.value === filterParams.payType,
              )}
              onChange={({ value }) =>
                setFilterParams((prev) => ({
                  ...prev,
                  page: 1,
                  payType: value,
                }))
              }
            />
          </div>

          <div className="mx-3" style={{ zIndex: 999 }}>
            <Select
              styles={{
                control: (base) => ({ ...base, width: "12rem" }),
              }}
              classNamePrefix="form-select-store"
              menuPosition="fixed"
              isSearchable={false}
              placeholder="Select Vendor Cert"
              options={data?.vendorCert}
              value={data?.vendorCert?.find(
                (item) => item.value === filterParams.cert,
              )}
              onChange={({ value }) =>
                setFilterParams((prev) => ({
                  ...prev,
                  page: 1,
                  cert: value,
                }))
              }
            />
          </div>

          <Button
            onClick={() =>
              setFilterParams((prev) => ({
                ...prev,
                minPrice: "",
                maxPrice: "",
                sort: "",
                item: "",
              }))
            }
            variant="white"
          >
            Reset
          </Button>
        </div>
      </div>
    </>
  );
}
